import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Internal components
import Title from "components/Title";
import Btn from "components/Btn";
import LanguagePicker from "components/LanguagePicker";
import Meta from "components/Meta";

// External components
import ReactPlayer from "react-player/vimeo";

// Contexts
import { DataContext } from "contexts/Data";

const Bakgrunn = () => {
    const { pathname } = useLocation();
    const { data, language, setLanguage } = useContext(DataContext);
    useEffect(() => {
        if (pathname === "/background") {
            setLanguage("en");
        } else if (pathname === "/bakgrunn") {
            setLanguage("no");
        }
    }, [pathname]);
    return (
        <>
            <Meta
                title={data.seo.bakgrunn.title || ""}
                description={data.seo.bakgrunn.description || ""}
                image={data.seo.bakgrunn.image || ""}
            />
            <LanguagePicker
                redirects={{
                    no: data.pages.bakgrunn.to.no,
                    en: data.pages.bakgrunn.to.en,
                }}
            />
            <section className="bakgrunn">
                <div className="container bakgrunn__container">
                    <div className="bakgrunn-thread-left" />
                    <div className="bakgrunn-thread-right" />
                    <Title
                        title={data.pages.bakgrunn.content.title[language]}
                        subtitle={
                            data.pages.bakgrunn.content.subtitle[language]
                        }
                    />
                    <div className="bakgrunn__video">
                        <div
                            style={{ marginTop: "5rem" }}
                            class="player-wrapper"
                        >
                            <ReactPlayer
                                width="100%"
                                height="100%"
                                className="react-player rounded overflow-hidden shadow border-vibrant"
                                config={{
                                    vimeo: {
                                        playerOptions: {
                                            color: "eabdac",
                                        },
                                    },
                                }}
                                controls
                                url="https://player.vimeo.com/video/585690954"
                            />
                        </div>
                    </div>

                    <div
                        className="color-box"
                        // dangerouslySetInnerHTML={{
                        //     __html: data.pages.bakgrunn.content.text[language],
                        // }}
                    >
                        <h3>
                            {language === "no" && (
                                <>
                                    Prosjektet Nålens makt startet i januar 2019
                                    med en serie av broderings workshops over 6
                                    uker. Workshopene brakte sammen kvinner med
                                    flyktning- og migrasjonsbakgrunn og kvinner
                                    fra lokalsamfunnet. Kvinnene fikk i oppgave
                                    å brodere i fellesskap et eget motiv som
                                    skulle uttrykke noe om sin identitet og
                                    kulturarv. Broderingsinstallasjonen er satt
                                    sammen av alle disse individuelle
                                    broderiene. «Nålens makt» handler om å
                                    styrke kvinners egen bevissthet, gjeninnføre
                                    brodering som uttrykksform og vise
                                    betydningen det kan ha.
                                </>
                            )}
                            {language === "en" && (
                                <>
                                    The Power of the Needle project started in
                                    January 2019 with a six-week series of
                                    embroidery workshops. The workshops have
                                    brought women with refugee and migrant
                                    backgrounds together with women from the
                                    local community. The main goal was for the
                                    women to embroider in unity, their own
                                    motifs expressing their identity and
                                    cultural heritage. All their embroideries
                                    are now part of the embroidery installation.
                                    “The Power of the Needle” aims to empower
                                    women through embroidery while reviving the
                                    craft.{" "}
                                </>
                            )}
                        </h3>
                        <blockquote>
                            {language === "no" && (
                                <>
                                    «Alt du trenger er en nål, en tråd og en
                                    fortelling»
                                </>
                            )}
                            {language === "en" && (
                                <>
                                    “All you need is one needle, one thread and
                                    one story”
                                </>
                            )}
                        </blockquote>
                        <p>
                            {language === "no" && (
                                <>
                                    Nålens makt er et prosjekt utviklet og
                                    produsert av Solveig Hessaa-Szwinto ved
                                    ARKIVET freds- og menneskerettighetssenter,
                                    sammen med kreativ koordinator Katrina Flett
                                    Gulbrandsen.
                                </>
                            )}
                            {language === "en" && (
                                <>
                                    The Power of the Needle is a project
                                    developed and directed by Solveig
                                    Hessaa-Szwinto at ARKIVET Peace and Human
                                    Rights Centre in Kristiansand, Norway,
                                    together with Creative Coordinator Katrina
                                    Flett Gulbrandsen.
                                </>
                            )}
                        </p>
                        <hr />
                        <p>
                            <strong>
                                {language === "no" && <>I samarbeid med:</>}
                                {language === "en" && (
                                    <>In collaboration with</>
                                )}
                            </strong>
                            <br />
                            <a href="http://www.husflid.no/">
                                Norges Husflidslag
                            </a>
                            <br />
                            <a href="https://www.kianorge.no/region/velferd-kristiansand">
                                KIA-kompetanse Kristiansand
                            </a>
                        </p>
                        <p>
                            <strong>
                                {language === "no" && <>Støttet av</>}
                                {language === "en" && <>Supported by</>}
                            </strong>
                            <br />
                            <a href="https://www.gjensidigestiftelsen.no/">
                                Gjensidigestiftelsen
                            </a>
                            <br />
                            <a href="https://www.kulturradet.no/">
                                {language === "no" && <>Kulturrådet</>}
                                {language === "en" && (
                                    <>The Arts Council Norway</>
                                )}
                            </a>
                            <br />
                            <a href="https://agderfk.no/">
                                Vest-Agder fylkeskommune
                            </a>
                        </p>
                    </div>
                </div>
                <Btn
                    className="btn--patch-vertical next-btn"
                    to={data.pages.inspirasjon.to[language]}
                >
                    {data.nextButton[language]}
                </Btn>
            </section>
        </>
    );
};

export default Bakgrunn;
